/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Group_ActionsInputs */

const en_palette_group_actions = /** @type {(inputs: Palette_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_palette_group_actions = /** @type {(inputs: Palette_Group_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Palette_Group_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const palette_group_actions = /** @type {((inputs?: Palette_Group_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Group_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_palette_group_actions(inputs)
	return en_palette_group_actions(inputs)
});